<template>
  <custom-dialog class="location-plan-dialog" :title="model.title" width="744px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false" label-position="top">
        <el-form-item :label="$t('location_plan_dialog.ji_hua_ming_cheng')" prop="scheduleName">
          <el-input v-model="form.scheduleName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('location_plan_dialog.ji_hua_zhuang_tai')" prop="state">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">{{ $t('Common.com_enable') }}</el-radio>
            <el-radio :label="0">{{ $t('Common.com_disable') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('location_plan_dialog.ji_hua_zhou_qi')" prop="goalTime11">
          <el-row :gutter="10">
            <el-col :span="6">
              <div style="border: 1px solid #dedede; padding: 0 8px">
                <div style="height: 40px; line-height: 40px">
                  <el-radio v-model="form.scheduleMethod" :label="2" @input="onChangeType">{{ $t('location_plan_dialog.an_zhou') }}</el-radio>
                </div>
                <el-checkbox-group v-model="checkWeekList" :disabled="form.scheduleMethod != 2">
                  <div><el-checkbox label="1">{{ $t('location_plan_dialog.xing_qi_yi') }}</el-checkbox></div>
                  <div><el-checkbox label="2">{{ $t('location_plan_dialog.xing_qi_er') }}</el-checkbox></div>
                  <div><el-checkbox label="3">{{ $t('location_plan_dialog.xing_qi_san') }}</el-checkbox></div>
                  <div><el-checkbox label="4">{{ $t('location_plan_dialog.xing_qi_si') }}</el-checkbox></div>
                  <div><el-checkbox label="5">{{ $t('location_plan_dialog.xing_qi_wu') }}</el-checkbox></div>
                  <div><el-checkbox label="6">{{ $t('location_plan_dialog.xing_qi_liu') }}</el-checkbox></div>
                  <div><el-checkbox label="7">{{ $t('location_plan_dialog.xing_qi_ri') }}</el-checkbox></div>
                </el-checkbox-group>
              </div>
            </el-col>
            <el-col :span="18">
              <div style="border: 1px solid #dedede; padding: 0 8px">
                <div style="height: 40px; line-height: 40px; display: flex; justify-content: space-between; align-items: center">
                  <el-radio v-model="form.scheduleMethod" :label="3" @input="onChangeType">{{ $t('location_plan_dialog.an_yue') }}</el-radio>
                  <div style="color: #606060; font-size: 12px">{{ $t('location_plan_dialog.kdjrqbjwxx') }}</div>
                </div>
                <div style="border-top: 1px solid #dedede; border-left: 1px solid #dedede">
                  <div class="day-box" :class="{ current: checkDayList.includes(`${item}`), disabled: form.scheduleMethod != 3 }" v-for="item in 31" :key="item" @click="onChangeDay(`${item}`)">
                    {{ item }}
                  </div>
                </div>
                <div class="remark">
                  <span v-if="checkDayList.length > 0">{{ $t('location_plan_dialog.mei_yue') }}{{ checkDayList.join(',') }}{{ $t('location_plan_dialog.ri_xiu_xi') }}</span>
                  <span v-else>{{ $t('location_plan_dialog.mei_ri_gong_zuo') }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      checkWeekList: [],
      checkDayList: [],
      inputVisible: false,
      inputValue: '',
      form: {
        locationScheduleId: '',
        locationId: '',
        scheduleName: '',
        scheduleMethod: 2,
        scheduleCondition: '', // 逗号分割
        state: 1,
      },
    };
  },
  computed: {
    rules() {
      return {
        scheduleName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
        state: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  mounted() {
    this.initForm();
  },
  methods: {
    initForm() {
      if (this.model.type === 'add') {
        this.form.locationId = this.model.data.locationId;
        return;
      }
      this.$setFormatData(this.form, this.model.data, 'locationId,locationScheduleId,scheduleName,scheduleMethod,scheduleCondition,state');
      if (this.form.scheduleMethod === 2) {
        this.checkWeekList = this.form.scheduleCondition.split(',');
      } else {
        this.checkDayList = this.form.scheduleCondition.split(',');
      }
    },
    closeDialog() {
      this.visible = false;
    },
    onChangeType() {
      if (this.form.scheduleMethod !== 2) {
        this.checkWeekList = [];
      } else if (this.form.scheduleMethod !== 3) {
        this.checkDayList = [];
      }
    },
    onChangeDay(value) {
      if (this.form.scheduleMethod !== 3) {
        return;
      }
      var index = this.checkDayList.findIndex(t => t === value);
      if (index === -1) {
        this.checkDayList.push(value);
        this.checkDayList.sort((a, b) => +a - +b);
      } else {
        this.checkDayList.splice(index, 1);
      }
    },
    onConfirm() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.checkWeekList = this.checkWeekList.filter(t => !!t);
          this.checkDayList = this.checkDayList.filter(t => !!t);
          if (this.form.scheduleMethod === 2 && this.checkWeekList.length === 0) {
            this.$message.error(this.$t('location_plan_dialog.qxzxqjdgzr'));
            return;
          }
          if (this.form.scheduleMethod === 3 && this.checkDayList.length === 31) {
            this.$message.error(this.$t('location_plan_dialog.qxzmydxxr'));
            return;
          }
          this.checkWeekList.sort((a, b) => +a - +b);
          if (this.model.type === 'add') {
            this.form.scheduleCondition = this.form.scheduleMethod === 2 ? this.checkWeekList.join(',') : this.checkDayList.join(',');
            this.$postJSON(apis.locationScheduleAdd, this.form, true).then(() => {
              this.$message({
                type: 'success',
                message: this.$t('Common.com_add_success'),
              });
              this.$emit('success');
              this.closeDialog();
            });
          } else {
            this.form.scheduleCondition = this.form.scheduleMethod === 2 ? this.checkWeekList.join(',') : this.checkDayList.join(',');
            this.$postJSON(apis.locationScheduleUpdate, this.form, true).then(() => {
              this.$message({
                type: 'success',
                message: this.$t('Common.com_edit_success'),
              });
              this.$emit('success');
              this.closeDialog();
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.location-plan-dialog {
  .el-form-item__content {
    line-height: 30px;
  }
  .el-checkbox__label {
    font-weight: normal;
  }
  .day-box {
    cursor: pointer;
    display: inline-block;
    border-right: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #000000;
    font-size: 13px;
    &.disabled {
      color: #c0c4cc;
      background-color: #edf2fc;
    }
    &.current {
      background-color: #ffdcd8;
    }
  }
  .remark {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #606060;
  }
}
</style>
